const TWITTER_MATCH = /^https?:\/\/twitter.com\/[a-zA-Z0-9_]*\/status(?:es)?\/(\d+)/;
export default function isTwitter(url) {
    const match = TWITTER_MATCH.exec(url);
    if (match) return match[1];
    return undefined;
};
